module.exports = __webpack_public_path__ + "static/media/jehyun-sung-483873-unsplash.e99cf491.jpg";